import { render, staticRenderFns } from "./CourseStatisticsTime.vue?vue&type=template&id=27645cac&scoped=true"
import script from "./CourseStatisticsTime.vue?vue&type=script&lang=js"
export * from "./CourseStatisticsTime.vue?vue&type=script&lang=js"
import style0 from "./CourseStatisticsTime.vue?vue&type=style&index=0&id=27645cac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27645cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27645cac')) {
      api.createRecord('27645cac', component.options)
    } else {
      api.reload('27645cac', component.options)
    }
    module.hot.accept("./CourseStatisticsTime.vue?vue&type=template&id=27645cac&scoped=true", function () {
      api.rerender('27645cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/CourseStatisticsTime.vue"
export default component.exports